<ng-container *ngIf="product">
  <div class="card card--product" [ngClass]="{ 'card--product--large': isLarge }">
    <a
      [target]="isExternalLink ? '_system' : null"
      [airLink]="productUrl"
      [userEventSource]="userEventSource"
      [userEventLabel]="product.title"
      [userEventObject]="userEventObject"
    >
      <div class="card__image">
        <figure>
          <air-focal-image [image]="product.primaryImage" [isCropped]="true"></air-focal-image>
        </figure>
      </div>

      <div class="card__stickers">
        <air-miles-sticker *ngIf="product" [product]="product" [size]="isLarge ? 'md' : undefined"></air-miles-sticker>
      </div>
      <div *ngIf="isExternalLink" class="card__icon"><i class="icon icon--sm icon-ui-logout"></i></div>
      <div class="card__text">
        <h4 *ngIf="product.title" class="card__title">{{ product.title }}</h4>
        <div *ngIf="product.shortDescription && !isDescriptionHidden" class="card__description">
          <p>{{ product.shortDescription }}</p>
        </div>
      </div>
    </a>
  </div>
</ng-container>
